import React from 'react';
import { TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { usePreventGameKeydownListening } from '@hooks/index';

const InputField = (props: TextFieldProps) => {
  const inputRef = usePreventGameKeydownListening();

  return <TextField {...props} inputRef={inputRef} variant="outlined" />;
};

export default InputField;
